import { Injectable } from '@angular/core';
import { ApiResponse } from '@core/interface/api-response.interface';
import { Observable } from 'rxjs';
import { CompanyCollectorCommissionTariffRepository } from '@domain/company-collector-commission-tariff/repositories/company-collector-commission-tariff.repository';
import { CompanyCollectorCommissionTariffService } from '@core/services/entities/company-collector-commission-tariff.service';
import { ListCompanyCollectorCommissionTariffRequestDto } from '@domain/company-collector-commission-tariff/dtos/list-company-collector-commission-tariff-request.dto';
import { GetCompanyCollectorCommissionTariffRequestDto } from '@domain/company-collector-commission-tariff/dtos/get-company-collector-commission-tariff-request.dto';
import { CompanyCollectorCommissionTariffResponseDto } from '@domain/company-collector-commission-tariff/dtos/company-collector-commission-tariff-response.dto';
import { PageableResponse } from '@core/interface/pageable.interface';
import { CreateCompanyCollectorCommissionTariffRequestDto } from '@domain/company-collector-commission-tariff/dtos/create-company-collector-commission-tariff-request.dto';
import { UpdateCompanyCollectorCommissionTariffRequestDto } from '@domain/company-collector-commission-tariff/dtos/update-company-collector-commission-tariff-request.dto';
import { RefId } from '@core/interface/ref-id.interface';

@Injectable({
  providedIn: 'root',
})
export class CompanyCollectorCommissionTariffRepositoryService implements CompanyCollectorCommissionTariffRepository {
  constructor(
    private companyCollectorCommissionTariffService: CompanyCollectorCommissionTariffService,
  ) {}

  list(
    request: ListCompanyCollectorCommissionTariffRequestDto,
  ): Observable<
    ApiResponse<PageableResponse<CompanyCollectorCommissionTariffResponseDto>>
  > {
    return this.companyCollectorCommissionTariffService.list(request);
  }

  get(
    request: GetCompanyCollectorCommissionTariffRequestDto,
  ): Observable<ApiResponse<CompanyCollectorCommissionTariffResponseDto[]>> {
    return this.companyCollectorCommissionTariffService.get(request);
  }

  create(
    request: CreateCompanyCollectorCommissionTariffRequestDto,
  ): Observable<ApiResponse<CompanyCollectorCommissionTariffResponseDto>> {
    return this.companyCollectorCommissionTariffService.create(request);
  }

  update(
    refId: string,
    request: UpdateCompanyCollectorCommissionTariffRequestDto,
  ): Observable<ApiResponse<CompanyCollectorCommissionTariffResponseDto>> {
    return this.companyCollectorCommissionTariffService.update(refId, request);
  }

  delete(
    request: RefId,
  ): Observable<ApiResponse<CompanyCollectorCommissionTariffResponseDto>> {
    return this.companyCollectorCommissionTariffService.delete(request);
  }
}
